import { Button } from '@acpaas-ui/react-components';
import { useDispatch } from 'react-redux';
import { fetchReset } from '../../../../actions/fetch.actions';
import SimpleSearch from '../../../../components/core/SimpleSearch';
import { MODALS } from '../../../../constants/modals.constants';
import { useAdminRouteGuard } from '../../../../hooks/admin/useAdminRouteGuard.hook';
import { useForm } from '../../../../hooks/useForm.hook';
import { useModal } from '../../../../hooks/useModal.hook';
import { useSimpleSearch } from '../../../../hooks/useSimpleSearch.hook';
import AddTemplateModal from '../../../../modals/admin/AddTemplateModal';
import UpdateTemplateModal from '../../../../modals/admin/UpdateTemplateModal';
import DeleteWarningModal from '../../../../modals/DeleteWarningModal';
import { ADMIN_TEMPLATES_RESOURCE } from '../../../../resources/admin/admin.templates.resource';
import templatesService from '../../../../services/api/templates.service';
import ResourceTable from '../../../core/ResourceTable';

const resource = ADMIN_TEMPLATES_RESOURCE;

const AdminTemplates = () => {
  const dispatch = useDispatch();
  const addTemplateModal = useModal(MODALS.ADD_TEMPLATE_MODAL);
  const updateTemplateModal = useModal(MODALS.UPDATE_TEMPLATE_MODAL);
  const deleteTemplateModal = useModal(MODALS.DELETE_TEMPLATE_MODAL);
  const templateForm = useForm({});

  useAdminRouteGuard();

  const handleDeleteRequest = () => {
    deleteTemplateModal.onOpen();
  };

  const handleDeleteConfirm = (onError, onSuccess) => {
    templatesService.remove(templateForm.data.id, {
      onError,
      onSuccess: () => {
        onSuccess();
        updateTemplateModal.onClose();
        templateForm.load({});
        dispatch(fetchReset(resource));
      }
    });
  };

  const handleTemplateOpen = (data) => {
    templateForm.load({ ...data, category: data?.categoryValue });
    updateTemplateModal.onOpen();
  };

  const simpleSearch = useSimpleSearch(resource, 'search');

  return (
    <div className="spo-o-admin-templates">
      <p className="u-margin-bottom">
        Sjablonen zijn bestanden die kunnen gedownload worden door bepaalde betrokkenen van een dossier en als basis
        kunnen dienen voor verschillende documenten en bijlagen in de applicatie.
      </p>
      <SimpleSearch className="u-margin-bottom-lg" {...simpleSearch} />
      <ResourceTable
        resource={resource}
        onRowClick={handleTemplateOpen}
        actions={[
          <Button
            key={'templates-add'}
            iconRight="ai-add"
            className="u-margin-right-sm"
            size="small"
            onClick={addTemplateModal.onOpen}
          >
            Sjabloon toevoegen
          </Button>
        ].filter((x) => !!x)}
      />
      {addTemplateModal.isOpen && <AddTemplateModal {...addTemplateModal} />}
      {updateTemplateModal.isOpen && (
        <UpdateTemplateModal
          {...updateTemplateModal}
          form={templateForm}
          onDelete={handleDeleteRequest}
          onUpdated={simpleSearch.onSearch}
        />
      )}
      {deleteTemplateModal.isOpen && <DeleteWarningModal {...deleteTemplateModal} onConfirm={handleDeleteConfirm} />}
    </div>
  );
};

export default AdminTemplates;
